<template>
  <div class="report-screen row justify-center">
    <div class="col-11 col-md-10">
      <div class="header">
        <h6>Report</h6>
        <!-- <div class="overall-report row bg-white">
          <div class="column data-slot col-6 q-pa-md">
            <p>Sales</p>
            <h4>654,000 ฿</h4>
          </div>
          <div class="column data-slot col-grow q-pa-md">
            <p>Orders</p>
            <h4>44</h4>
          </div>
          <div class="column data-slot col-grow q-pa-md">
            <p>Customers</p>
            <h4>10</h4>
          </div>
        </div> -->
        <div class="search-bar row justify-between">
          <q-input
            class="col-grow"
            outlined
            rounded
            dense
            placeholder="search customer..."
          >
            <template v-slot:prepend>
              <q-icon name="search" />
            </template>
          </q-input>
          <q-btn
            label="Refresh"
            outline
            rounded
            icon="refresh"
            style="margin-left: 10px"
          ></q-btn>
        </div>
      </div>
      <div class="content">
        <p>Found {{ customers.length }} customers.</p>
        <ReportCard
          v-for="(customer, index) in customers"
          :key="index"
          :customer="customer"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "Report",
  components: {
    ReportCard: () => import("@/ui/pages/report/ReportCard.vue"),
  },
  data() {
    return {
      mockCustomer: [
        {
          name: "Jack Alion",
          phone: "062-1234567",
          email: "customer@gmail.com",
          totalPurchase: 45000,
          totalOrders: 4,
          products: [
            {
              name: "C-Force",
            },
            {
              name: "Oishi green tea",
            },
            {
              name: "Oishi lemon tea",
            },
            {
              name: "Puera water",
            },
          ],
        },
        {
          name: "Fuse Poramet",
          phone: "062-1234567",
          email: "customer@gmail.com",
          totalPurchase: 45000,
          totalOrders: 4,
          products: [
            {
              name: "C-Force",
            },
            {
              name: "Oishi green tea",
            },
            {
              name: "Oishi lemon tea",
            },
            {
              name: "Puera water",
            },
          ],
        },
        {
          name: "Tony Pee",
          phone: "062-1234567",
          email: "customer@gmail.com",
          totalPurchase: 45000,
          totalOrders: 4,
          products: [
            {
              name: "C-Force",
            },
            {
              name: "Oishi green tea",
            },
            {
              name: "Oishi lemon tea",
            },
            {
              name: "Puera water",
            },
          ],
        },
        {
          name: "Percy J",
          phone: "062-1234567",
          email: "customer@gmail.com",
          totalPurchase: 45000,
          totalOrders: 4,
          products: [
            {
              name: "C-Force",
            },
            {
              name: "Oishi green tea",
            },
            {
              name: "Oishi lemon tea",
            },
            {
              name: "Puera water",
            },
          ],
        },
        {
          name: "Harry Potter",
          phone: "062-1234567",
          email: "customer@gmail.com",
          totalPurchase: 45000,
          totalOrders: 4,
          products: [
            {
              name: "C-Force",
            },
            {
              name: "Oishi green tea",
            },
            {
              name: "Oishi lemon tea",
            },
            {
              name: "Puera water",
            },
          ],
        },
      ],
    };
  },
  computed: {
    ...mapState({
      customers: (state) => state["sale"]["customers"],
    }),
  },
  mounted(){
    console.log("load report data");
  }
};
</script>

<style lang="scss" scoped>

* {
  padding: 0;
  margin: 0;
}
.search-bar {
  padding: 10px 0;
}
.report-screen {
  margin: 10px 0;
}
.overall-report {
  margin-top: 10px;
  border-radius: 25px;
  padding: 20px 10px;
}
.data-slot {
  background-color: #f2f3f4;
  padding: 10px;
  border-radius: 15px;
  margin: 0 10px;
  p {
    color: darkgrey;
  }
  h4 {
    color: #2c2a74;
    text-align: right;
  }
  @media screen and (max-width: 600px) {
    margin: 10px;
  }
}

</style>